import { Outlet } from "react-router";

const CartManagementPage = () => {
  return (
    <>
      <Outlet />
    </>
  );
};

export default CartManagementPage;
